import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles/Product.css';
import { useNavigate } from 'react-router-dom';

// ✅ Your image imports (unchanged)
import embosed from '../assets/112.webp';
import laminate from '../assets/225.webp';
import lominous from '../assets/454.webp';
import metal from '../assets/672.webp';
import ultra from '../assets/783.webp';
import villa from '../assets/889.webp';
import fire from '../assets/908.webp';

const products = [
  {
    id: 1,
    title: "LUXURY EMBOSED DOORS",
    image: embosed,
    brief: "Weather-resistant and stylish, perfect for modern homes.",
    details:
      "Our exterior doors combine beauty and durability, offering a secure entrance while enhancing curb appeal. Built with materials like fiberglass and steel, they provide insulation, soundproofing, and resistance to the elements."
  },
  {
    id: 2,
    title: "LUXURY LAMINATE DOORS",
    image: laminate,
    brief: "Sophisticated entry doors crafted for luxurious villas.",
    details:
      "Villa doors reflect grandeur with carved wood, reinforced frames, and intricate designs. Available in various finishes, they serve as a stylish focal point and enhance the entrance of high-end residences."
  },
  {
    id: 3,
    title: "LUXURY LOMINOUS DOORS",
    image: lominous,
    brief: "Reliable emergency exit doors meeting all safety standards.",
    details:
      "These doors are designed to provide fast and safe egress in emergencies. Made with fire-resistant materials, they comply with local safety codes and come with panic hardware, automatic closing systems, and seals."
  },
  {
    id: 4,
    title: "LUXURY METAL DOORS",
    image: metal,
    brief: "Elegant and secure entrances for modern apartments.",
    details:
      "Apartment doors focus on privacy and safety while blending seamlessly with modern interiors. Sound-dampening materials and multi-point locks ensure quiet living and peace of mind."
  },
  {
    id: 5,
    title: "LUXURY ULTRA LAM DOORS",
    image: ultra,
    brief: "Modern statement doors with pivot functionality.",
    details:
      "Pivot doors rotate on a central axis rather than side hinges, creating a stunning architectural element. These doors are available in large formats and premium finishes like glass, steel, and composite."
  },
  {id: 6,
    title: "LUXURY VILLA DOORS",
    image: villa,
    brief: "Modern statement doors with pivot functionality.",
    details:
      "Pivot doors rotate on a central axis rather than side hinges, creating a stunning architectural element. These doors are available in large formats and premium finishes like glass, steel, and composite."
   },
   {id: 7,
    title: "FIRE EXIT DOORS",
    image: fire,
    brief: "Modern statement doors with pivot functionality.",
    details:
      "Pivot doors rotate on a central axis rather than side hinges, creating a stunning architectural element. These doors are available in large formats and premium finishes like glass, steel, and composite."
   }

];

const ProductShowcase = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const navigate = useNavigate();
  const handleProductClick = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <section className="product-showcase" id="products">
      <h2>Door Collection</h2>
      <p className="section-description">
        Explore our premium door collection designed with elegance, durability, and functionality in mind.
      </p>

      <div className="product-row top-row">
        {products.slice(0, 3).map((product, index) => (
          <div
            className="product-card"
            key={product.id}
            onClick={() => handleProductClick(product.id)}
            data-aos="fade-up"
            data-aos-delay={`${index * 100}`}
          >
            <img src={product.image} alt={product.title} className="product-thumb" />
            <h3>{product.title}</h3>
            <p>{product.brief}</p>
          </div>
        ))}
      </div>

      <div className="product-row bottom-row">
        {products.slice(3).map((product, index) => (
          <div
            className="product-card"
            key={product.id}
            onClick={() => handleProductClick(product.id)}
            data-aos="fade-up"
            data-aos-delay={`${index * 100}`}
          >
            <img src={product.image} alt={product.title} className="product-thumb" />
            <h3>{product.title}</h3>
            <p>{product.brief}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductShowcase;
